module.exports = __webpack_public_path__ + "img/03.a3f2b308.png";